import "./styles.css"
import ReactDOM from "react-dom/client";

export const replaceHydrateFunction = () => {
    return (element: any, container: any) => {
        const root = ReactDOM.createRoot(container)
        root.render(element)
    }
}
